export default __webpack_public_path__ + "static/img_contact@2x.png";